'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('@chakra-ui/react');
var reactUtils = require('@chakra-ui/react-utils');
var utils = require('@chakra-ui/utils');
var React = require('react');
require('../../illustrations/BrokerRatingSuccess.js');
require('../../illustrations/BrokerRating.js');
require('../../illustrations/Documents.js');
require('../../illustrations/EmptyFinance.js');
require('../../illustrations/EmptyFinanceWithAvatar.js');
require('../../illustrations/EmptyMessenger.js');
require('../../illustrations/EmptyReaprofile.js');
require('../../illustrations/EmptyStatistics.js');
require('../../illustrations/Logic.js');
require('../../illustrations/MoneyExchange.js');
require('../../illustrations/PropertyMoney.js');
require('../../illustrations/PropertySold.js');
var RealtyTypeApartment = require('../../illustrations/RealtyTypeApartment.js');
var RealtyTypeCommercial = require('../../illustrations/RealtyTypeCommercial.js');
var RealtyTypeHouse = require('../../illustrations/RealtyTypeHouse.js');
var RealtyTypeOther = require('../../illustrations/RealtyTypeOther.js');
var RealtyTypeSite = require('../../illustrations/RealtyTypeSite.js');
require('../../illustrations/RobotCircled.js');
require('../../illustrations/Robot.js');
require('../../illustrations/ThoughtProcess.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["realtyType", "isElevated", "isSelected"];

/**
 * Current realty types to automatically display the right icon to its type.
 */
var BROKER_REALTY_TYPES = {
  commercial: {
    icon: RealtyTypeCommercial.RealtyTypeCommercial
  },
  apartment: {
    icon: RealtyTypeApartment.RealtyTypeApartment
  },
  house: {
    icon: RealtyTypeHouse.RealtyTypeHouse
  },
  site: {
    icon: RealtyTypeSite.RealtyTypeSite
  },
  other: {
    icon: RealtyTypeOther.RealtyTypeOther
  }
};
var _createContext = reactUtils.createContext({
    name: 'BrokerLeadCardContext',
    errorMessage: 'useBrokerLeadCardContext: `context` is undefined. Seems you forgot to wrap BrokerLeadCard components in `<BrokerLeadCard />`.'
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  BrokerLeadCardProvider = _createContext2[0],
  useBrokerLeadCardContext = _createContext2[1];
/**
 * BrokerLeadCard
 *
 * A card to display the most relevant information of a property. It adapts to the state the property is in.
 */
var BrokerLeadCard = react.forwardRef(function (props, ref) {
  var realtyType = props.realtyType;
  props.isElevated;
  props.isSelected;
  var rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = react.useMultiStyleConfig('BrokerLeadCard', props);
  return /*#__PURE__*/React__default["default"].createElement(BrokerLeadCardProvider, {
    value: {
      realtyType: realtyType
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref,
    className: utils.cx('chakra-broker-lead-card', props.className),
    __css: styles.card
  }, rest))));
});
BrokerLeadCard.displayName = 'BrokerLeadCard';
exports.BROKER_REALTY_TYPES = BROKER_REALTY_TYPES;
exports.BrokerLeadCard = BrokerLeadCard;
exports.BrokerLeadCardProvider = BrokerLeadCardProvider;
exports.useBrokerLeadCardContext = useBrokerLeadCardContext;